import type { Order } from '@src/domains/orders/types/order';
import { getSaleItems, type DetailedSaleItem } from '@src/domains/sales';

export interface OrderReservation {
  saleId: string;
  reservationId: string | null;
  saleItem: DetailedSaleItem;
  isPackageItem: boolean;
}

export const getOrderReservations = (order: Order): OrderReservation[] =>
  order.sales.flatMap((sale) =>
    getSaleItems(sale).map((saleItem) => ({
      saleId: sale.id,
      reservationId: saleItem.reservationId,
      saleItem,
      isPackageItem: !!saleItem.productPackageUnitId,
    })),
  );
